import React, { useEffect, useRef, useState } from 'react';
import Icon from '../../../components/dashboard/DashboardIcons';

export default function ActionsMenu({ items, testId }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const visibleItems = items.filter(Boolean);
  return (
    <div className="relative inline-block" ref={ref}>
      <button onClick={() => setOpen((o) => !o)} className="flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-xs font-semibold text-slate-600 hover:border-teal-300" data-testid={testId}>
        إجراءات <Icon name="chevronDown" className="w-3 h-3" />
      </button>
      {open && (
        <div className="absolute left-0 z-20 mt-1 w-48 rounded-lg border border-slate-200 bg-white py-1 shadow-lg" data-testid={`${testId}-menu`}>
          {visibleItems.map((it, i) => (
            <button
              key={i}
              onClick={() => { setOpen(false); it.onClick(); }}
              className={`flex w-full items-center gap-2 px-3 py-2 text-right text-sm hover:bg-slate-50 ${it.danger ? 'text-red-600' : 'text-slate-700'}`}
              data-testid={it.testId}
              title={it.label}
            >
              <Icon name={it.icon} className="w-3.5 h-3.5" /> {it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
